import arrowDownImg from "aible/images/arrow-down.svg";
import arrowRotateLeftImg from "aible/images/arrow-rotate-left-light.svg";
import arrowSidewaysImg from "aible/images/arrow-sideways.svg";
import awardImg from "aible/images/award.svg";
import balanceImg from "aible/images/balance.svg";
import balanceGreyImg from "aible/images/balance-grey.svg";
import blueprintImg from "aible/images/blueprint.svg";
import blueprintWhiteImg from "aible/images/blueprint-white.svg";
import calendarImg from "aible/images/calendar.svg";
import calendarWhiteImg from "aible/images/calendar-white.svg";
import chartImg from "aible/images/chart.svg";
import chartPurpleImg from "aible/images/chart-purple.svg";
import chartScatterImg from "aible/images/chart-scatter.svg";
import chatImg from "aible/images/chat.svg";
import chatPurpleImg from "aible/images/chat-purple.svg";
import chatLinesImg from "aible/images/chat-lines.svg";
import chevronDownImg from "aible/images/chevron-down.svg";
import chevronRightImg from "aible/images/chevron-right.svg";
import chevronUpImg from "aible/images/chevron-up.svg";
import checkImg from "aible/images/check.svg";
import checkBoxImg from "aible/images/check-box.svg";
import checkGreenImg from "aible/images/check-green.svg";
import checkPurpleImg from "aible/images/check-purple.svg";
import columnsImg from "aible/images/columns.svg";
import columnsOneImg from "aible/images/columns-one.svg";
import columnsTwoImg from "aible/images/columns-two.svg";
import columnsThreeImg from "aible/images/columns-three.svg";
import databaseImg from "aible/images/database.svg";
import databaseNoneImg from "aible/images/database-none.svg";
import databaseWhiteImg from "aible/images/database-white.svg";
import expandLeftImg from "aible/images/expand-left.svg";
import expandRightImg from "aible/images/expand-right.svg";
import editPurpleImg from "aible/images/edit-purple.svg";
import folderAddPurpleImg from "aible/images/folder-add-purple.svg";
import gearImg from "aible/images/gear.svg";
import infoGreyImg from "aible/images/info-grey.svg";
import layersImg from "aible/images/layers.svg";
import layersNoneImg from "aible/images/layers-none.svg";
import layersPurpleImg from "aible/images/layers-purple.svg";
import layersWhiteImg from "aible/images/layers-white.svg";
import layersNoneWhiteImg from "aible/images/single-group-light.svg";
import layersNoneWhiteGreyImg from "aible/images/layers-none-white-grey.svg";
import linkImg from "aible/images/link.svg";
import linkWhiteImg from "aible/images/link-white.svg";
import listImg from "aible/images/list.svg";
import listGreyImg from "aible/images/list-grey.svg";
import mindImg from "aible/images/mind.svg";
import moneyImg from "aible/images/money.svg";
import monitoringImg from "aible/images/monitoring.svg";
import monitoringWhiteImg from "aible/images/monitoring-white.svg";
import noImg from "aible/images/no.svg";
import pieChartImg from "aible/images/chart-pie-light.svg";
import plusImg from "aible/images/plus-purple.svg";
import plusPurpleImg from "aible/images/plus-purple.svg";
import rocketImg from "aible/images/rocket.svg";
import rocketGreyImg from "aible/images/rocket-grey.svg";
import rowsImg from "aible/images/rows.svg";
import rowsWhiteImg from "aible/images/rows-white.svg";
import searchImg from "aible/images/search.svg";
import starGreyImg from "aible/images/star-grey.svg";
import tagImg from "aible/images/tag.svg";
import tagPurpleImg from "aible/images/tag-purple.svg";
import targetImg from "aible/images/target.svg";
import targetGreyImg from "aible/images/target-grey.svg";
import targetWhiteImg from "aible/images/target-white.svg";
import thumbsDownImg from "aible/images/thumbs-down.svg";
import thumbsDownPurpleImg from "aible/images/thumbs-down-purple.svg";
import thumbsDownWhiteImg from "aible/images/thumbs-down-white.svg";
import thumbsUpImg from "aible/images/thumbs-up.svg";
import thumbsUpPurpleImg from "aible/images/thumbs-up-purple.svg";
import thumbsUpWhiteImg from "aible/images/thumbs-up-white.svg";
import timesImg from "aible/images/times.svg";
import timesDarkImg from "aible/images/times-dark.svg";
import timesPurpleImg from "aible/images/times-purple.svg";
import timesRedImg from "aible/images/times-red.svg";
import toolsPurpleImg from "aible/images/tools-purple.svg";
import trashImg from "aible/images/trash.svg";
import trashWhiteImg from "aible/images/trash-white.svg";
import trashGreyImg from "aible/images/trash-grey.svg";
import userImg from "aible/images/user.svg";
import userWhiteImg from "aible/images/user-white.svg";
import userAddGreyImg from "aible/images/user-add-grey.svg";
import userAddPurpleImg from "aible/images/user-add-purple.svg";
import userGroupImg from "aible/images/user-group.svg";
import warningImg from "aible/images/warning.svg";
import warningRedImg from "aible/images/warning-red.svg";
import warningWhiteImg from "aible/images/warning-white.svg";
import warningYellowImg from "aible/images/warning-yellow.svg";
import magicImg from "aible/images/magic.svg";
import csvImg from "aible/images/csv.svg";
import starImg from "aible/images/star.svg";
import settingsImg from "aible/images/settings.svg";
import boxImg from "aible/images/box.svg";
import revenueImg from "aible/images/revenue.svg";
import resourcingImg from "aible/images/resourcing.svg";
import profitImg from "aible/images/profit.svg";
import FolderPickerIcon from "images/folder-migrate.svg";
import refreshImg from "aible/images/refresh.svg";

const IMAGES = {
  arrowDown: arrowDownImg,
  arrowRotateLeft: arrowRotateLeftImg,
  arrowSideways: arrowSidewaysImg,
  award: awardImg,
  balance: balanceImg,
  balanceGrey: balanceGreyImg,
  scales: balanceImg,
  scalesGrey: balanceGreyImg,
  blueprint: blueprintImg,
  blueprintWhite: blueprintWhiteImg,
  calendar: calendarImg,
  calendarWhite: calendarWhiteImg,
  chart: chartImg,
  chartPurple: chartPurpleImg,
  chartScatter: chartScatterImg,
  chat: chatImg,
  chatPurple: chatPurpleImg,
  chatLines: chatLinesImg,
  check: checkImg,
  checkBox: checkBoxImg,
  checkGreen: checkGreenImg,
  checkPurple: checkPurpleImg,
  checkmark: checkImg,
  checkmarkGreen: checkGreenImg,
  checkmarkPurple: checkPurpleImg,
  chevronDown: chevronDownImg,
  chevronRight: chevronRightImg,
  right: chevronRightImg,
  chevronUp: chevronUpImg,
  column: columnsImg,
  columns: columnsImg,
  columnsOne: columnsOneImg,
  columnsTwo: columnsTwoImg,
  columnsThree: columnsThreeImg,
  comment: chatImg,
  up: chevronUpImg,
  data: databaseImg,
  database: databaseImg,
  dataset: databaseImg,
  dataWhite: databaseWhiteImg,
  databaseWhite: databaseWhiteImg,
  datasetWhite: databaseWhiteImg,
  dataNone: databaseNoneImg,
  databaseNone: databaseNoneImg,
  datasetNone: databaseNoneImg,
  delete: trashImg,
  deny: noImg,
  down: chevronDownImg,
  editPurple: editPurpleImg,
  expandLeft: expandLeftImg,
  expandRight: expandRightImg,
  folderAddPurple: folderAddPurpleImg,
  folderPicker: FolderPickerIcon,
  gear: gearImg,
  info: infoGreyImg,
  layers: layersImg,
  layersNone: layersNoneImg,
  layersNoneWhite: layersNoneWhiteImg,
  layersNoneWhiteGrey: layersNoneWhiteGreyImg,
  layersPurple: layersPurpleImg,
  layersWhite: layersWhiteImg,
  link: linkImg,
  linkWhite: linkWhiteImg,
  list: listImg,
  listGrey: listGreyImg,
  listGray: listGreyImg,
  money: moneyImg,
  monitoring: monitoringImg,
  monitoringWhite: monitoringWhiteImg,
  mind: mindImg,
  no: noImg,
  noData: databaseNoneImg,
  noDatabase: databaseNoneImg,
  noDataset: databaseNoneImg,
  noLayers: layersNoneImg,
  pieChart: pieChartImg,
  plus: plusImg,
  plusPurple: plusPurpleImg,
  refresh: refreshImg,
  remove: noImg,
  rocket: rocketImg,
  rocketGrey: rocketGreyImg,
  row: rowsImg,
  rows: rowsImg,
  rowWhite: rowsWhiteImg,
  rowsWhite: rowsWhiteImg,
  search: searchImg,
  starGrey: starGreyImg,
  tag: tagImg,
  tagPurple: tagPurpleImg,
  target: targetImg,
  targetGrey: targetGreyImg,
  targetWhite: targetWhiteImg,
  thumbsDown: thumbsDownImg,
  thumbsDownPurple: thumbsDownPurpleImg,
  thumbsDownWhite: thumbsDownWhiteImg,
  thumbsUp: thumbsUpImg,
  thumbsUpPurple: thumbsUpPurpleImg,
  thumbsUpWhite: thumbsUpWhiteImg,
  times: timesImg,
  timesDark: timesDarkImg,
  timesPurple: timesPurpleImg,
  timesRed: timesRedImg,
  toolsPurple: toolsPurpleImg,
  trash: trashImg,
  trashWhite: trashWhiteImg,
  trashGrey: trashGreyImg,
  undo: arrowRotateLeftImg,
  user: userImg,
  userWhite: userWhiteImg,
  userAddGrey: userAddGreyImg,
  userAddPurple: userAddPurpleImg,
  userGroup: userGroupImg,
  warning: warningImg,
  warningRed: warningRedImg,
  warningWhite: warningWhiteImg,
  warningYellow: warningYellowImg,
  magic: magicImg,
  csv: csvImg,
  star: starImg,
  box: boxImg,
  settings: settingsImg,
  profit: profitImg,
  revenue: revenueImg,
  cost: resourcingImg
};

export default IMAGES;
